"use client";

import React, { useEffect, useState } from "react";
import { Button, Input, Typography } from "antd";
import { IoSearchOutline } from "@react-icons/all-files/io5/IoSearchOutline";
import { AiOutlineCloseCircle } from "@react-icons/all-files/ai/AiOutlineCloseCircle";
import { useRouter, useSearchParams } from "next/navigation";

import styles from "./SearchBar.module.scss";
import classnames from "classnames";
import { useSearchStore } from "../../utils/useSearchStore";
import AntdThemeProvider from "@/app/[lang]/components/AntdThemeProvider";

const { Text } = Typography;

interface SearchBarProps {
  handleClose?: () => void;
}

export const SearchBar = ({ handleClose }: SearchBarProps) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const searchData = useSearchStore((state) => state.searchData);
  const isLoading = useSearchStore((state) => state.isLoading);
  const fetchSearchData = useSearchStore((state) => state.fetchSearchData);

  const handleSubmit = () => {
    if (!error && input) {
      handleClose && handleClose();
      router.push(`/cauta?query=${input}`, { scroll: false });
    }
  };

  const [input, setInput] = useState<string>('');
  const [error, setError] = useState(false);

  useEffect(() => {
    const query = searchParams.get("query");
    if (query) {
      setInput(query);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!searchData && !isLoading) {
      fetchSearchData();
    }
  }, [searchData, isLoading, fetchSearchData]);

  useEffect(() => {
    if (input && (input.length < 3 || input.length > 50)) {
      setError(true);
    } else {
      setError(false);
    }
  }, [input]);

  if (!searchData) {
    return null
  }

  return (
    <AntdThemeProvider>
    <div className={ classnames( 'search-bar', styles.searchSection ) }>
      <div className={ styles.inputWrapper }>
        <Input
          type="text"
          placeholder={ searchData.data.attributes.searchButtonText }
          className={ styles.input }
          prefix={<IoSearchOutline fontSize={16.5} />}
          suffix={
            <>
              {input && (
                <AiOutlineCloseCircle
                  fontSize="24px"
                  color="black"
                  onClick={() => setInput("")}
                  cursor={"pointer"}
                  style={{ marginRight: "24px" }}
                />
              )}
              <Button className={ styles.searchButton } onClick={() => handleSubmit()} color="danger">Caută</Button>
            </>
          }
          onSubmit={() => handleSubmit()}
          onKeyUp={(e) => e.key === "Enter" && handleSubmit()}
          value={input}
          onChange={(e) => setInput(e.currentTarget.value)}
          status={error ? "error" : ""}
        />

        <div className={ styles.inputHelpText }>
          {error && (
            <Text className={ styles.errorText }>{ searchData.data.attributes.searchError }</Text>
          )}
        </div>
      </div>
    </div>
    </AntdThemeProvider>
  );
};
